import React, { useState } from 'react';
import { IUserJson } from '@scale/shared/types/user';

import { Button } from '@scale/scaleui';

import TaskerScreeningBenchmarksCsvUploadModal from 'react-scale/corp/views/rapid/TaskerScreeningUtils/TaskerScreeningBenchmarksCsvUploadModal';

interface TaskerScreeningBenchmarkCsvUploadToolProps {
  user: IUserJson;
  setNeedsFetch: (needsFetch: boolean) => void;
}

const TaskerScreeningBenchmarkCsvUploadTool: React.FC<
  TaskerScreeningBenchmarkCsvUploadToolProps
> = ({ user: _user, setNeedsFetch }) => {
  const [modalOpen, setModalOpen] = useState<boolean>(false);

  return (
    <>
      <Button
        className="mt-4"
        variant="secondary"
        onClick={() => {
          setModalOpen(true);
        }}
      >
        Upload Benchmarks in Bulk - CSV
      </Button>
      <TaskerScreeningBenchmarksCsvUploadModal
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
        setNeedsFetch={setNeedsFetch}
      />
    </>
  );
};

export default TaskerScreeningBenchmarkCsvUploadTool;
